<template>
  <div>
    <menubar />
    <div class="container">

      <div id="title" class="title-btn d-flex justify-content-between align-items-center">

        <div class="d-flex justify-content-start">
          <img src="/img/05_slash.svg" />
          <p class="h1">問い合わせ一覧</p>
        </div>

      </div>

      <table class="inquiry_table component_table" cellpadding="5">
        <thead>
          <tr>
            <th class="th--content">内容抄写</th>
            <th class="th--user-name">発信者氏名</th>
            <th class="th--date">発信日時</th>
            <th class="th--checkbox">選択</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(inquiry, index) in inquiries" :key="index">
            <td class="td--content">
              <a href="#" @click="openInquiryDetailModal(inquiry)">
                {{ inquiry.text }}
              </a>
            </td>
            <td class="td--user-name">{{ inquiry.name }}</td>
            <td class="td--date">{{ showLocalDateTime(inquiry.created_at, "/", " ") }}</td>
            <td class="td--checkbox" v-if="true">
              <input type="checkbox" v-bind:value="inquiry.id" v-model="selected" />
            </td>
          </tr>
        </tbody>
      </table>

      <div class="row div__delete">
        <div class="text-end">
          <button class="btn btn-red" style="font-size: 0.9rem" @click="deleteInquiries">まとめて削除</button>
        </div>
      </div>

    </div>
    <footerComponent />

  </div>

    <!-- inq-dtl-mdl: 問い合わせの詳細表示用モーダル -->
    <modal class="inq-dtl-mdl" ref="inquiryDetailModal">
      <template v-slot:modalTitle> 問い合わせ詳細 </template>
      <template v-slot:modal-content="{ closeModal }">
        <div class="msg-group">

          <div class="msg__section">
            <span> 送信者氏名: </span>
            <h4> {{openedInquiry.name}} </h4>
          </div>

          <div class="msg__section">
            <span> 送信者メールアドレス: </span>
            <h4> {{openedInquiry.email}} </h4>
          </div>

          <div class="msg__section">
            <span> 送信者電話番号: </span>
            <h4> {{openedInquiry.phone_number}} </h4>
          </div>
          <hr>
          <div class="msg__section">
            <span> 本文: </span>
            <div class="msg__panel">
              {{openedInquiry.text}} 
            </div>
          </div>
          <hr>

          <div class="msg__section">
            <span>種別: </span>
            <h5 v-if="openedInquiry.inquiry_type!=null"> {{type_en2ja[openedInquiry.inquiry_type.name]}} </h5>
          </div>

          <div class="msg__section">
            <span>送信日時: </span>
            <h5> {{openedInquiry.created_at}} </h5>
          </div>


          <div class="msg__foot">
            <button class="btn btn-purple" @click="leaveInquiryDetailModal">戻る</button>
          </div>
        
        </div>

      </template>
    </modal>
</template>

<script>
import { defineComponent, reactive } from 'vue';
import { Inertia } from '@inertiajs/inertia'
import { Link } from '@inertiajs/inertia-vue3'
import modal from '@/Pages/Components/modal.vue';
import menubar from '@/Pages/JVTA/menu_jvta.vue';
import footerComponent from '@/Pages/Components/footer.vue';
import showLocalDate from '@/Pages/Components/showLocalDate.js';


// import { useForm } from '@inertiajs/inertia-vue3'
export default defineComponent({
    data() {
    return {
      selected: [],
      openedInquiry: Object, //詳細モーダルで表示するメッセージ
      type_en2ja: { // [TODO] ハードコーディングなのでテーブルに値自体持たせる
        'request': "依頼",
        'question': "質問",
        'others': "その他",
      }
    };
},
  components: {
    Link,
    menubar,
    modal,
    footerComponent,
  },
  props: {inquiries: Object},
  beforeMount(){
    console.log(this.inquiries);
  },
methods :{
    showLocalDateTime: function (date, separator_date, separator_time) {
      return showLocalDate.showLocalDateTime(date, separator_date, separator_time);
    },
    openInquiryDetailModal(inquiry){
      console.log(inquiry);
      this.openedInquiry = inquiry;
      console.log(this.$refs);
      this.$refs.inquiryDetailModal.openModal({is_wide: true, is_long: true});      
    },
    leaveInquiryDetailModal(){
      this.$refs.inquiryDetailModal.closeModal();
    },
    deleteInquiries: function () {
      if (this.selected.length == 0) {
        alert("削除列の一つ以上のチェックボックスにチェックしてください");
        return;
      }
      if (confirm("この操作はやり直せません、本当に用語集を削除しますか？")) {
        this.$inertia.delete(
          route("inquiries.destroy", this.selected.join(",")),
          {
            onSuccess: () => {
              alert("選択された用語集を削除しました");
              this.selected = [];
            },
          }
        );
      } else {
        return;
      }
    },
  }

},);
</script>

<style lang="scss" scoped>
// hogr
// タイトル部分「用語集一覧」のcss
.container {
  #title {
    margin: 3rem 0;
    img {
      width: 3rem;
      height: 3rem;
    }
    p {
      color: #666666;
    }
  }
  .title-btn {
    margin: 3rem 0;
    #title {
      margin: 0;
      img {
        width: 3rem;
        height: 3rem;
      }
      p {
        color: #666666;
      }
    }
  }
}


.inquiry_table {
  width: 100%;
  table-layout: fixed;
  overflow-wrap: break-word;
  word-wrap: break-word;
  thead {text-align: center;}
  td {padding: 0.5rem 1rem;}
  tbody {text-align: center;}
}
.th--content{
  width: auto;
}
.th--type{width: 6rem;}
.th--user-name{width: 9rem;}
.th--date{width: 12rem;}
.th--checkbox{width: 3rem;}

.td--content{
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}



.msg-group{
  padding: 0 2rem;
}
.msg__section{
  margin: 1rem 0;
  text-align: start;
}

.msg__foot{
  margin: 1rem 0;
  text-align: center;
}






.text-red {
  color: red;
}
.col-select {
  width: 5%;
}
.col-content {
  width: 50%;
}
.col-name {
  width: 10%;
}
.col-type {
  width: 15%;
}
.col-archive-status {
  width: 10%;
}
.col-delete {
  width: 10%;
}

.div__delete{
  margin-top: 2rem;
  margin-bottom: 3rem;
}

</style>
